import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetCalculateReimbursementPreview,
	GetCalculateReimbursementPreviewParams,
	GetCalculateReimbursementPreviewResponse,
} from 'domain/usecases/private/refund/request-preview';

export class RemoteGetCalculateReimbursementPreview
	implements GetCalculateReimbursementPreview
{
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetCalculateReimbursementPreviewResponse>,
	) {}

	async get(
		params: GetCalculateReimbursementPreviewParams,
		signal?: AbortSignal,
	): Promise<GetCalculateReimbursementPreviewResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
